import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from './ui/tooltip';
import { Gauge } from 'lucide-react';

function scoreColor(score) {
  if (score >= 85) return 'bg-accent/15 text-accent border-accent/30';
  if (score >= 70) return 'bg-emerald-500/10 text-emerald-700 border-emerald-500/25';
  if (score >= 55) return 'bg-amber-500/10 text-amber-700 border-amber-500/25';
  return 'bg-muted text-muted-foreground border-border';
}

const LABELS = {
  price: 'Price (40%)', duration: 'Duration (20%)', stops: 'Stops (15%)',
  baggage: 'Baggage (10%)', schedule: 'Schedule (10%)', fare_quality: 'Fare quality (5%)',
};

export const ScoreChip = ({ score, breakdown, size = 'md' }) => {
  const cls = scoreColor(score);
  const pad = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center gap-1.5 rounded-full border font-semibold tabular ${pad} ${cls} cursor-help`} data-testid="flightdeals-score-chip">
            <Gauge className="h-3.5 w-3.5" />
            {score}<span className="opacity-60 font-normal">/100</span>
          </span>
        </TooltipTrigger>
        <TooltipContent className="w-64 p-3" data-testid="flightdeals-score-tooltip">
          <p className="font-semibold text-sm mb-1">FlightDeals Score</p>
          <p className="text-xs text-muted-foreground mb-2">Our internal 0–100 comparison score. It reflects overall value — it is NOT influenced by affiliate commission.</p>
          {breakdown && (
            <div className="space-y-1">
              {Object.entries(breakdown).map(([k, v]) => (
                <div key={k} className="flex items-center justify-between text-xs">
                  <span className="text-muted-foreground">{LABELS[k] || k}</span>
                  <span className="tabular font-medium">{Math.round(v.value)}</span>
                </div>
              ))}
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
